import React from 'react';
interface SectionHeadingProps {
  title: string;
  eyebrow?: string;
  description?: string;
  id?: string;
  tone?: 'light' | 'dark';
}
export function SectionHeading({
  title,
  eyebrow,
  description,
  id,
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className="mx-auto flex max-w-3xl flex-col items-center gap-1 text-center" data-id="element-178" data-mp="3jzndka2w3xin">
      {eyebrow && <p className="text-[0.62rem] font-black uppercase tracking-[0.24em] text-azure sm:text-xs" data-id="element-179" data-mp="bk3oln99519e">
          {eyebrow}
        </p>}
      <h2 id={id} className={`font-display text-lg uppercase leading-[1.05] sm:text-2xl lg:text-3xl ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-180" data-mp="gionnjcrpew9">
        {title}
      </h2>
      <span aria-hidden="true" className="h-1 w-14 rounded-full bg-solar" data-id="element-181" data-mp="6rkdcwy1ei7r" />
      {description && <p className={`font-body text-[0.8rem] leading-snug sm:text-sm ${isDark ? 'text-white/80' : 'text-steel'}`} data-id="element-182" data-mp="uhelj17evilo">
          {description}
        </p>}
    </div>;
}